import { useEffect, useState } from 'react'

// locals
import HealthService from 'service/HealthService'
import { IGetDoctorTimeTableList } from 'types/HealthType'
import DateUtil from 'utils/DateUtil'
import { groupBy } from 'utils/Miscellaneous'

export default function useGetDoctorAppointmentTable(
  selectedDoctorId: number,
  dateFromList: Date,
  isCalendar: boolean = false
) {
  const [timeTable, setTimeTable] = useState<IGetDoctorTimeTableList[] | []>([])
  const selectedDate = DateUtil.getWeekStartEndFromDate(dateFromList)
  const [tableWeek, setTableWeek] = useState(selectedDate)
  const [availableDates, setAvailableDates] = useState({ start: 0, end: 0 })
  const [selectedAppointment, setSelectedAppointment] = useState<IGetDoctorTimeTableList>()
  const [sidebarVisible, setSidebarVisible] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    HealthService.getHealtServiceDetailByDoctorId(selectedDoctorId).then((res) =>
      setAvailableDates({
        start: res.data.reservationStartDay,
        end: res.data.reservationEndDay,
      })
    )
  }, [selectedDoctorId])

  useEffect(() => {
    setLoading(true)
    HealthService.getDoctorAppointmentTableList({
      healthServiceDoctorId: selectedDoctorId,
      startDate: DateUtil.formatDateToString(tableWeek.start),
      endDate: DateUtil.formatDateToString(tableWeek.end),
    })
      .then((res) => setTimeTable(res.data))
      .finally(() => setLoading(false))

    /* Reset selected appointment time */
    if (!isCalendar) setSelectedAppointment(undefined)
  }, [selectedDoctorId, tableWeek.start, tableWeek.end, isCalendar])

  useEffect(() => {
    const selectedDate = DateUtil.getWeekStartEndFromDate(dateFromList)
    setTableWeek(selectedDate)
  }, [dateFromList, selectedDoctorId])

  const dailyAppointments: [] | Record<string, IGetDoctorTimeTableList[]> = !!timeTable.length
    ? groupBy(timeTable, (v) => DateUtil.formatStringToDate(v.reservationStartHour))
    : []

  return {
    availableDates,
    tableWeek,
    setTableWeek,
    selectedAppointment,
    setSelectedAppointment,
    sidebarVisible,
    setSidebarVisible,
    dailyAppointments,
    loading,
  }
}
